import { MESSAGE_FIELD } from "views/Constants";
export const MESSAGES_WIDGET_TYPE = "messages";
const widgetPayload = (view, widget) => ({
  name: view.getWidgetTitleByWidget(widget),
  description: widget.description,
  context: widget.context,
  config: { type: MESSAGES_WIDGET_TYPE, group_by: [], metrics: [] }
});
const widgetFields = (widget) => {
  var _a;
  const config = widget.config;
  const fields = (_a = config == null ? void 0 : config.fields) != null ? _a : [];
  return (config == null ? void 0 : config.showMessageRow) && fields.length > 0 && !fields.includes(MESSAGE_FIELD) ? [...fields, MESSAGE_FIELD] : fields;
};
const createMessagesWidgetSummaryRequest = (view, widget, scope, queryFilters) => {
  var _a, _b, _c, _d, _e, _f;
  return {
    type: "widget",
    payload: {
      ...widgetPayload(view, widget),
      search: {
        query: (_b = (_a = scope.query) == null ? void 0 : _a.query_string) != null ? _b : "",
        streams: scope.streams,
        stream_categories: (_c = scope.streamCategories) != null ? _c : [],
        timerange: scope.timerange,
        fields: widgetFields(widget),
        filters: [...(_d = queryFilters == null ? void 0 : queryFilters.toJS()) != null ? _d : [], ...(_f = (_e = widget.filters) == null ? void 0 : _e.toJS()) != null ? _f : []]
      }
    }
  };
};
export const createSelectedMessagesSummaryRequest = (view, widget, messages) => ({
  type: "widget",
  payload: {
    ...widgetPayload(view, widget),
    selection: {
      messages: messages.map(({ index, id }) => ({ index, id })),
      fields: widgetFields(widget)
    }
  }
});
export default createMessagesWidgetSummaryRequest;
